import { useMutation } from '@tanstack/react-query'
import { validateCallToken } from '../services'
import { CallToken } from '../components/TokenValidationModal/types'

export const useValidateCallToken = () => {
  return useMutation({
    mutationFn: (data: CallToken) => validateCallToken(data),
  })
}
